ACC.savedcarts = {

    _autoload: [
        ["bindRestoreSavedCartClick", $(".js-restore-saved-cart").length != 0],
        ["bindDeleteSavedCartLink", $('.js-delete-saved-cart').length != 0],
        ["bindDeleteConfirmLink", $('.js-savedcart_delete_confirm').length != 0],
        ["bindSaveCartForm", $(".js-save-cart-link").length != 0 || $(".js-update-saved-cart").length != 0],
        ["bindUpdateUploadingSavedCarts", $(".js-uploading-saved-carts-update").length != 0],
        "bindSaveCartFormx",
        "datePicker",
        "saveCartSimple",
        "triggerCartRfq",
        "countCommentRfq",
        "countCommentQuote"
    ],

    $savedCartRestoreBtn: {},
    $currentCartName: {},
    referenceRfqVal: true,
    valref: "",

    bindRestoreSavedCartClick: function () {
        $(".js-restore-saved-cart").click(function (event) {

            event.preventDefault();
            var popupTitle = $(this).data('restore-popup-title');
            var cartId = $(this).data('savedcart-id');
            var url = ACC.config.encodedContextPath + '/my-account/saved-carts/' + cartId + '/restore';

            $.get(url).done(function (data) {
                ACC.colorbox.open(popupTitle, {
                    html: data,
                    width: 500,
                    onComplete: function () {
                        ACC.common.refreshScreenReaderBuffer();
                        ACC.savedcarts.bindRestoreModalHandlers();
                        ACC.savedcarts.bindPostRestoreSavedCartLink();

                        var popup = $('#popup_confirm_savedcart_restore'),
                            height = popup.height();

                        popup.closest('#cboxLoadedContent').height(height);
                        popup.closest('#cboxContent').height(height + 80);
                    },
                    onClosed: function () {
                        ACC.common.refreshScreenReaderBuffer();
                    }
                });
            });
        });
    },

    bindRestoreModalHandlers: function () {

        ACC.savedcarts.$savedCartRestoreBtn = $('.js-save-cart-restore-btn');
        ACC.savedcarts.$currentCartName = $('.js-current-cart-name');

        $(".js-prevent-save-active-cart").on('change', function (event) {
            if ($(this).prop('checked') === true) {
                ACC.savedcarts.$currentCartName.attr('disabled', 'disabled');
                ACC.savedcarts.$savedCartRestoreBtn.removeAttr('disabled');
            } else {
                ACC.savedcarts.$currentCartName.removeAttr('disabled');
                var inputVal = ACC.savedcarts.$currentCartName.val();
                if (inputVal == "" && inputVal.length === 0) {
                    ACC.savedcarts.$savedCartRestoreBtn.attr('disabled', 'disabled');
                }
            }
        });

        ACC.savedcarts.$currentCartName.on('focus', function (event) {
            $('.js-restore-current-cart-form').removeClass('has-error');
            $('.js-restore-error-container').html('');
        });

        ACC.savedcarts.$currentCartName.on('blur', function (event) {
            if (this.value == "" && this.value.length === 0) {
                ACC.savedcarts.$savedCartRestoreBtn.attr('disabled', 'disabled');
            } else {
                ACC.savedcarts.$savedCartRestoreBtn.removeAttr('disabled');
            }
        });
    },

    bindPostRestoreSavedCartLink: function () {
        var keepRestoredCart = true;
        var preventSaveActiveCart = false;

        $(document).on("click", '.js-keep-restored-cart', function (event) {
            keepRestoredCart = $(this).prop('checked');
        });

        $(document).on("click", '.js-prevent-save-active-cart', function (event) {
            preventSaveActiveCart = $(this).prop('checked');
        });

        $(document).on("click", '.js-save-cart-restore-btn', function (event) {

            event.preventDefault();
            $(this).prop("disabled", true);
            var cartName = $('#activeCartName').val();
            var url = $(this).data('restore-url');
            var postData = {
                preventSaveActiveCart: preventSaveActiveCart,
                keepRestoredCart: keepRestoredCart,
                cartName: cartName
            };
            $.post(url, postData).done(function (response, data, status) {

                if (response.result == "unavailableProducts" || response.result == "ok") {
                    var url = ACC.config.encodedContextPath + "/cart"
                    window.location.replace(url);
                } else {
                    if (response.result == "error") {
                        var errorMsg = response.message.responseText.slice(1, -1);
                        $('.js-restore-current-cart-form').addClass('has-error');
                        $('.js-restore-error-container').html(errorMsg);
                        $('.js-savedcart_restore_confirm_modal').colorbox.resize();
                    }
                }
            });
        });

        $(document).on("click", '.js-cancel-restore-btn', function (event) {
            ACC.colorbox.close();
        });
    },

    bindDeleteSavedCartLink: function () {
        $(document).on("click", '.js-delete-saved-cart', function (event) {
            event.preventDefault();
            var cartId = $(this).data('savedcart-id');
            var popupTitle = $(this).data('delete-popup-title');

            ACC.colorbox.open(popupTitle, {
                inline: true,
                className: "js-savedcart_delete_confirm_modal",
                href: "#popup_confirm_savedcart_delete_" + cartId,
                width: '500px',
                onComplete: function () {
                    $(this).colorbox.resize();
                }
            });
        });
    },

    bindDeleteConfirmLink: function () {
        $(document).on("click", '.js-savedcart_delete_confirm', function (event) {
            event.preventDefault();
            var cartId = $(this).data('savedcart-id');
            var url = ACC.config.encodedContextPath + '/my-account/saved-carts/' + cartId + '/delete';
            $.ajax({
                url: url,
                type: 'DELETE',
                success: function (response) {
                    ACC.colorbox.close();
                    var url = ACC.config.encodedContextPath + "/my-account/saved-carts"
                    window.location.replace(url);
                }
            });
        });

        $(document).on("click", '.js-savedcart_delete_confirm_cancel', function (event) {
            ACC.colorbox.close();
        });
    },

    bindSaveCartForm: function () {
        ACC.savedcarts.charactersLeftInit();
        var form = $('#saveCartForm');
        var saveCart = false;
        var showSaveCartFormCallback = function () {
            var title = $('#saveCart').data("saveCartTitle");

            if ($(window).width() > 640) {
                ACC.colorbox.open("", {
                    href: "#saveCart",
                    inline: true,
                    width: "840px",
                    height: "430px",
                    onOpen: function () {
                        if ($('#saveCartName').val()) {
                            ACC.savedcarts.disableSaveCartButton(false);
                        }
                    },
                    onComplete: function () {
                        var maxValInit = $(".commentQuote").attr("maxlength");
                        $('#charNumQuote span').text(maxValInit);
                        $(".commentQuote").keyup(function () {
                            var len = $(this).val().length;
                            var maxVal = $(this).attr("maxlength");
                            if (len >= maxVal) {
                                $(this).val($(this).val().substring(0, maxVal));
                                $('#charNumQuote span').text(0);
                            } else {
                                $('#charNumQuote span').text(maxVal - len);
                            }
                        });
                        $(this).colorbox.resize();
                        saveCart = false;
                        $('input[name="deliveryAdress"]').val($('select#deliveryAdress option:selected').val());
                        $('input[name="deliveryMode"]').val($('select#deliveryMode option:selected').val());
                    },
                    onClosed: function () {

                        if (saveCart) {
                            form.submit();
                        }
                        document.getElementById("saveCartForm").reset();
                        ACC.savedcarts.charactersLeftInit();
                    }
                });
            }
        };

        $(document).on("click", ".js-save-cart-link, .js-update-saved-cart", function (e) {
            e.preventDefault();
            ACC.common.checkAuthenticationStatusBeforeAction(showSaveCartFormCallback);
            $('.addressDeliveryList').trigger('change');
            /* Contentsquare */
            ACC.track.contentsquareAPVTracking("offer-request");
            /* Contentsquare */
        }).on("click", "a.account-without-address", function (e) {
            e.preventDefault();
            $('.alert.account-without-address').removeClass('display-none');
        }).on("click", ".alert.account-without-address .close", function (e) {
            e.preventDefault();
            $('.alert.account-without-address').addClass('display-none');
        });

        $(document).on("click", '#saveCart #cancelSaveCartButton', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });

        $('#saveCartName').keyup(function () {
            // enable the save cart button
            $('#saveCart #saveCartButton').prop('disabled', this.value.trim() == "" ? true : false);
            // limit the text length
            var maxchars = 255;
            var value = $('#localized_val').attr('value');
            var tlength = $(this).val().length;
            remain = maxchars - parseInt(tlength);
            $('#remain').text(value + ' : ' + remain);
        });

        $('#saveCartDescription').keyup(function () {
            var maxchars = 255;
            var value = $('#localized_val').attr('value');
            var tlength = $(this).val().length;
            remain = maxchars - parseInt(tlength);
            $('#remainTextArea').text(value + ' : ' + remain);
        });

        $(document).on("click", '#saveCart #saveCartButton', function (e) {
            e.preventDefault();
            saveCart = true;
            $.colorbox.close();
        });
    },

    bindSaveCartFormx: function () {
        ACC.savedcarts.charactersLeftInit();
        var form = $('#saveCartForm');
        var saveCart = false;
        var productCode = $('#alertMeProductCode').val() ? $('#alertMeProductCode').val() : "";

        var alertMeAction = function () {

            var email = $('#alertMeEmail').val() ? $('#alertMeEmail').val() : "";
            $.ajax({
                type: "POST",
                url: ACC.config.alertMeWhenProductInStockUrl,
                data: {productCode: productCode, email: email},
                statusCode: {
                    401: function () {
                        //location.href = ACC.config.loginUrl;
                    }
                },
                success: function (data) {

                    if (data == "alreadyExistedForNonConnectedUser") {
                        //already Existed notification stock For Non ConnectedUser
                        $(".alreadyExistedForNonConnectedUser").removeClass("hidden");
                        $(".alreadyExistedForConnectedUser, .addNotificationSuccessfullyForNonConnectedUser, .userNonExists").addClass("hidden");
                    }

                    if (data == "userNonExists") {
                        //user Non Exists (Non connected user)
                        $(".userNonExists").removeClass("hidden");
                        $(".alreadyExistedForNonConnectedUser, .alreadyExistedForConnectedUser").addClass("hidden");
                    }

                    if (data == "AddNotificationSuccessfullyForNonConnectedUser") {
                        $(".addNotificationSuccessfullyForNonConnectedUser").removeClass("hidden");
                        $(".alreadyExistedForConnectedUser, .alreadyExistedForNonConnectedUser, .userNonExists").addClass("hidden");
                        $("#alertMeEmail, #alertMeButton").addClass("hidden");
                    }

                    if (data == "alreadyExistedForConnectedUser") {
                        //already Existed Notification stock For Connected User
                        $(".alreadyExistedForConnectedUser").removeClass("hidden");
                        $.colorbox.close();
                    }
                    if (data == "alreadyExistedForConnectedUser") {
                        //already Existed Notification stock For Connected User
                        $(".alreadyExistedForConnectedUser").removeClass("hidden");
                        $.colorbox.close();
                    }

                    if (data == "AddNotificationSuccessfullyForConnectedUser") {
                        // Add Notification stock  Successfully For Connected User
                        $(".addNotificationSuccessfullyForConnectedUser").removeClass("hidden");
                        $(".js-alert-me-when-productInStock, .js-alert-me-connected-user, .alreadyExistedForNonConnectedUser").addClass("hidden");
                        $.colorbox.close();
                    }

                    $.colorbox.resize();
                }
            });
        };
        var showAlertMeFormCallback = function () {
            var title = $('#alertMe').data("alertMeTitle");

            ACC.colorbox.open(title, {
                href: "#alertMe",
                inline: true,
                width: "620px",
                onOpen: function () {
                    if ($('#alertMeEmail').val()) {
                        ACC.savedcarts.disableSaveCartButton(false);
                    }
                    $("#alertMeEmail").val('');
                    $("#alertMeEmail, #alertMeButton").removeClass("hidden");
                },
                onComplete: function () {
                    $(this).colorbox.resize();
                    saveCart = false;
                },
                onClosed: function () {
                    $(".alreadyExistedForNonConnectedUser").addClass("hidden");
                    $(".userNonExists").addClass("hidden");
                    $(".addNotificationSuccessfullyForNonConnectedUser").addClass("hidden");

                    ACC.savedcarts.charactersLeftInit();
                }
            });
        };

        $(document).on("click", ".js-alert-me-when-productInStock", function (e) {
            e.preventDefault();
            showAlertMeFormCallback();
        });

        $(document).on("click", ".js-alert-me-connected-user", function (e) {
            e.preventDefault();
            alertMeAction();
        });

        $(document).on("click", '#saveCart #cancelSaveCartButton', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });

        $('#alertMeEmail').keyup(function () {
            // enable the save cart button
            $('#alertMe #alertMeButton').prop('disabled', this.value.trim() == "" ? true : false);
            // limit the text length
//					var maxchars = 255;
//					var value=$('#localized_val').attr('value');
//					var tlength = $(this).val().length;
//					remain = maxchars - parseInt(tlength);
//		        	$('#remain').text(value+' : '+remain);
        });


        $(document).on("click", '#alertMe #alertMeButton', function (e) {
            e.preventDefault();
            alertMeAction();
            //saveCart = true;
            //$.colorbox.close();
        });
    },

    disableSaveCartButton: function (value) {
        $('#saveCart #saveCartButton').prop('disabled', value);
    },

    charactersLeftInit: function () {
        $('#remain').text($('#localized_val').attr('value') + ' : 255');
        $('#remainTextArea').text($('#localized_val').attr('value') + ' : 255');
    },

    bindUpdateUploadingSavedCarts: function () {
        var cartIdRowMapping = $(".js-uploading-saved-carts-update").data("idRowMapping");
        var refresh = $(".js-uploading-saved-carts-update").data("refreshCart");
        if (cartIdRowMapping && refresh) {
            var interval = $(".js-uploading-saved-carts-update").data("refreshInterval");
            var arrCartIdAndRow = cartIdRowMapping.split(',');
            var mapCartRow = new Object();
            var cartCodes = [];
            for (i = 0; i < arrCartIdAndRow.length; i++) {
                var arrValue = arrCartIdAndRow[i].split(":");
                if (arrValue != "") {
                    mapCartRow[arrValue[0]] = arrValue[1];
                    cartCodes.push(arrValue[0]);
                }
            }

            if (cartCodes.length > 0) {
                setTimeout(function () {
                    ACC.savedcarts.refreshWorker(cartCodes, mapCartRow, interval)
                }, interval);
            }
        }
    },

    refreshWorker: function (cartCodes, mapCartRow, interval) {
        $.ajax({
            dataType: "json",
            url: ACC.config.encodedContextPath + '/my-account/saved-carts/uploadingCarts',
            data: {
                cartCodes: cartCodes
            },
            type: "GET",
            traditional: true,
            success: function (data) {
                if (data != undefined) {
                    var hidden = "hidden";
                    var rowId = "#row-";
                    for (i = 0; i < data.length; i++) {
                        var cart = data[i];

                        var index = $.inArray(cart.code, cartCodes);
                        if (index > -1) {
                            cartCodes.splice(index, 1)
                        }
                        var rowIdIndex = mapCartRow[cart.code];
                        if (rowIdIndex != undefined) {
                            var rowSelector = rowId + rowIdIndex;
                            $(rowSelector + " .js-saved-cart-name").removeClass("not-active");
                            $(rowSelector + " .js-saved-cart-date").removeClass("hidden");
                            $(rowSelector + " .js-file-importing").remove();
                            $(rowSelector + " .js-saved-cart-description").text(cart.description);
                            var numberOfItems = cart.entries.length;
                            $(rowSelector + " .js-saved-cart-number-of-items").text(numberOfItems);
                            $(rowSelector + " .js-saved-cart-total").text(cart.totalPrice.formattedValue);
                            if (numberOfItems > 0) {
                                $(rowSelector + " .js-restore-saved-cart").removeClass(hidden);
                            }
                            $(rowSelector + " .js-delete-saved-cart").removeClass(hidden);
                        }
                    }
                }
                ;

                if (cartCodes.length > 0) {
                    setTimeout(function () {
                        ACC.savedcarts.refreshWorker(cartCodes, mapCartRow, interval)
                    }, interval);
                }
            }
        })
    },

    datePicker: function () {
        var LimitDate = $(".js-delevery-limit").text();
        var langCurrent = $(".lang-current").text();
        var options = $.extend({},
            $.datepicker.regional[langCurrent], {
                minDate: 0,
                maxDate: "+" + LimitDate + "M",
                showOn: "button",
                buttonImage: "/_ui/responsive/theme-amds/images/calendre-icon.png",
                buttonImageOnly: true,
            }
        );
        $("#desiredDeliveryDate").datepicker(options);
    },

    triggerCartRfq: function () {
        $(document).on("click", ".js-rfq-popup", function (e) {
            e.preventDefault();
            if ($(window).width() < 640) {
                window.location.replace('cart/createRfq');
            } else {
                ACC.savedcarts.saveCartRfq();

            }
            /* Contentsquare */
            ACC.track.contentsquareAPVTracking("rfq-request");
            /* Contentsquare */
        });
    },


    saveCartRfq: function () {

        $.ajax({
            url: ACC.config.loginNotHardUrl,
            statusCode: {
                401: function () {
                    location.href = ACC.config.loginUrl;
                }
            },
            success: function (data) {
                if (data == "authenticated") {
                    if (ACC.savedcarts.referenceRfqVal) {
                        ACC.savedcarts.valref = $('.js-reference-rfq').val();
                        ACC.savedcarts.referenceRfqVal = false;
                    }

                    var title = $('.confirmDevis').data("saveCartTitle");
                    ACC.colorbox.open("", {
                        href: ".confirmDevis",
                        inline: true,
                        width: "840px",
                        height: "680px",
                        onOpen: function () {
                            $('.addressDeliveryList').trigger('change')
                        },
                        onComplete: function () {
                            $('.js-save-simple').one('click', function () {
                                $(this).addClass("disabled");
                            });

                            $('.close-btn-alert').on('click', function () {
                                $(this).siblings(".error-msg").addClass("hidden");
                            });

                            var maxValInit = $(".commentRfq").attr("maxlength");
                            $('#charNumRfq span').text(maxValInit);
                            $(".commentRfq").keyup(function () {
                                var len = $(this).val().length;
                                var maxVal = $(this).attr("maxlength");
                                if (len >= maxVal) {
                                    $(this).val($(this).val().substring(0, maxVal));
                                    $('#charNumRfq span').text(0);
                                } else {
                                    $('#charNumRfq span').text(maxVal - len);
                                }
                            });

                            function isValidDate(input) {
                                var regEx;
                                if ($(".lang-current").text() == "de") {
                                    regEx = /^([0-2][0-9]|(3)[0-1])(\.)(((0)[0-9])|((1)[0-2]))(\.)\d{4}$/;
                                } else if ($(".lang-current").text() == "nl") {
                                    regEx = /^([0-2][0-9]|(3)[0-1])(\-)(((0)[0-9])|((1)[0-2]))(\-)\d{4}$/;
                                } else {
                                    regEx = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
                                }
                                return input.match(regEx) != null;
                            }



                            $(document).on("submit", '.devisForm', function (e) {
                                e.preventDefault();
                                var givenValue = $(".confirmDevis #desiredDeliveryDate").val();
                                if (givenValue != "" && !isValidDate(givenValue)) {
                                    $(".confirmDevis #desiredDeliveryDate").val("");
                                    $(".confirmDevis #desiredDeliveryDate").closest(".datedelivery").addClass("invalid");
                                } else {
                                    $(".confirmDevis #desiredDeliveryDate").closest(".datedelivery").removeClass("invalid");
                                    var $form = $('.confirmDevis .devisForm');
                                    var $redirectUrl = $('.js-redirect-url').text();
                                    var $referenceRfq = $('.js-reference-rfq').val();
                                    if ($referenceRfq != "") {
                                        $(".without-ref-rfq").addClass("hidden");
                                        $(".with-ref-rfq").removeClass("hidden");
                                        $(".with-ref-rfq .ref-text").text(" " + $referenceRfq);
                                    } else {
                                        $(".with-ref-rfq").addClass("hidden");
                                        $(".without-ref-rfq").removeClass("hidden");
                                    }
                                    $(".error-msg").text("");
                                    $(".error-msg").addClass("hidden");
                                    $.ajax({
                                        url: $form.attr("action"),
                                        data: $form.serialize(),
                                        type: $form.attr("method") ? $form.attr("method").toUpperCase() : "GET",
                                        success: function () {
                                            ACC.colorbox.open(title = "", {
                                                href: "#successSaveCart",
                                                inline: true,
                                                width: "600px",
                                                height: "400px",
                                                onClosed: function () {
                                                    var url = ACC.config.encodedContextPath + $redirectUrl
                                                    window.location.replace(url);
                                                },
                                                onComplete: function () {
                                                    $(".js-btn-redirect").on("click", function () {
                                                        var url = ACC.config.encodedContextPath + $redirectUrl
                                                        window.location.replace(url);
                                                    });
                                                },
                                            });
                                            /* Contentsquare */
                                            ACC.track.contentsquareAPVTracking("rfq-request-sent");
                                            /* Contentsquare */
                                        },
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            if (jqXHR.status && jqXHR.status == 400) {
                                                $(".error-msg").text(jqXHR.responseText);
                                            } else {
                                                $(".error-msg").text("Something went wrong");
                                            }
                                            $(".error-msg").removeClass("hidden");
                                        }
                                    });
                                    return false;
                                }
                            });


                        },
                        onClosed: function () {
                            $(document).off("submit", '.devisForm');
                            $(".confirmDevis .js-reference-rfq").val(ACC.savedcarts.valref);
                            $(".confirmDevis #desiredDeliveryDate").closest(".datedelivery").removeClass("invalid");
                            $(".confirmDevis #desiredDeliveryDate").val("");
                            $(".confirmDevis #comment").val("");
                            $(".confirmDevis .chooseDeal").load(location.href + " .confirmDevis .chooseDeal");
                            $(".confirmDevis #submit-button").load(location.href + " .confirmDevis .js-btn-submit-rfq");
                        },
                    });
                }
            },
            complete : function(resultat, statut) {
                ACC.formQuoteMobile.handleDeliveryModeList();
            }
        });
    },

    saveCartSimple: function () {
        $('.js-save-simple').one('click', function () {
            $(this).addClass("disabled");
        });
        $('.close-btn-alert').on('click', function () {
            $(this).siblings(".error-msg").addClass("hidden");
        });

        $(document).on("submit", '#saveCart', function () {
            var $form = $('#saveCart .formPopup');
            var $redirectUrl = $('.js-save-cart-redirect-url').text();
            var $reference = $('.js-reference-offer').val();
            if ($reference != "") {
                $(".without-ref").addClass("hidden");
                $(".with-ref").removeClass("hidden");
                $(".with-ref span").text(" " + $reference);
            } else {
                $(".with-ref").addClass("hidden");
                $(".without-ref").removeClass("hidden");
            }
            $.ajax({
                url: $form.attr("action"),
                data: $form.serialize(),
                type: $form.attr("method") ? $form.attr("method").toUpperCase() : "GET",
                success: function (data) {
                    if (!data) {
                        var url = ACC.config.encodedContextPath + "/cart";
                        window.location.replace(url);
                    } else {
                        ACC.colorbox.open(title = "", {
                            href: "#successSaveCart",
                            inline: true,
                            width: "600px",
                            height: "400px",
                            onClosed: function () {
                                var url = ACC.config.encodedContextPath + $redirectUrl
                                window.location.replace(url);
                            },
                            onComplete: function () {
                                $(".js-btn-redirect").on("click", function () {
                                    var url = ACC.config.encodedContextPath + $redirectUrl
                                    window.location.replace(url);
                                });
                            },
                        });
                        $("#successQuoteMobile").removeClass("hidden");
                        /* Contentsquare */
                        ACC.track.contentsquareAPVTracking("offer-request-sent");
                        /* Contentsquare */
                    }

                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $(".error-msg").text("error 2");
                }
            });
            return false;
        });
    },
    countCommentQuote: function () {
        var maxValInit = $(".commentQuote").attr("maxlength");
        $('#charNumQuote span').text(maxValInit);
        $(".commentQuote").keyup(function () {
            var len = $(this).val().length;
            var maxVal = $(this).attr("maxlength");
            if (len >= maxVal) {
                $(this).val($(this).val().substring(0, maxVal));
                $('#charNumQuote span').text(0);
            } else {
                $('#charNumQuote span').text(maxVal - len);
            }
        });
    },
    countCommentRfq: function () {
        var maxValInit = $(".commentRfq").attr("maxlength");
        $('#charNumRfq span').text(maxValInit);
        $(".commentRfq").keyup(function () {
            var len = $(this).val().length;
            var maxVal = $(this).attr("maxlength");
            if (len >= maxVal) {
                $(this).val($(this).val().substring(0, maxVal));
                $('#charNumRfq span').text(0);
            } else {
                $('#charNumRfq span').text(maxVal - len);
            }
        });
    }
}
